import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { HomeNewComponent } from './components/pages/home/home.component';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';
import { homeComponent } from './components/pages/home/home.component';


const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: homeComponent,            
    pathMatch:'full'
  },
  {
    path: '**',
    redirectTo: 'home'
  },
  { path: 'product/:id', component:ProductDetailsComponent},

];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: false, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
